import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom"
import { useEffect } from "react"
import HomePage from "./pages/HomePage"
import ModelsPage from "./pages/ModelsPage"
import AttachmentsPage from "./pages/AttachmentsPage"
import ApplicationsPage from "./pages/ApplicationsPage"
import GroundCarePage from "./pages/applications/GroundCarePage"
import RoadMaintenancePage from "./pages/applications/RoadMaintenancePage"
import WinterApplicationsPage from "./pages/applications/WinterApplicationsPage"
import MunicipalServicesPage from "./pages/applications/MunicipalServicesPage"
import AirportOperationsPage from "./pages/applications/AirportOperationsPage"
import FacilityManagementPage from "./pages/applications/FacilityManagementPage"
import PartnersPage from "./pages/PartnersPage"
import AboutPage from "./pages/AboutPage"
import ContactPage from "./pages/ContactPage"
import "./index.css"

// Component to handle scrolling to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  
  return null;
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/models" element={<ModelsPage />} />
          <Route path="/attachments" element={<AttachmentsPage />} />
          <Route path="/applications" element={<ApplicationsPage />} />
          <Route path="/applications/ground-care" element={<GroundCarePage />} />
          <Route path="/applications/road-maintenance" element={<RoadMaintenancePage />} />
          <Route path="/applications/winter" element={<WinterApplicationsPage />} />
          <Route path="/applications/municipal" element={<MunicipalServicesPage />} />
          <Route path="/applications/airport" element={<AirportOperationsPage />} />
          <Route path="/applications/facility-management" element={<FacilityManagementPage />} />
          <Route path="/partners" element={<PartnersPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
      </div>
    </Router>
  )
}

export default App
